import { useIntl } from 'react-intl';

import { Typography } from '@/components/Typography';
import { commonMessages } from '@/messages/common';

import { ReactComponent as AdjustTheGiftsIcon } from '@/assets/4gift-adjust-the-gift.svg';

import * as S from '../SendGiftModal.styles';

export const AdjustTheGifts = () => {
  const { formatMessage } = useIntl();
  return (
    <S.InfoBoxBody>
      <AdjustTheGiftsIcon />
      <Typography
        fontFamily='italianPlate'
        fontWeight='bold'
        mb='s035'
        mt='s035'
        scale='p0'
        textTransform='uppercase'
      >
        {formatMessage(commonMessages.sendGiftAdjustGifts)}
      </Typography>
      <Typography textAlign='center'>
        {formatMessage(commonMessages.sendGiftAdjustGiftsDesc)}
      </Typography>
    </S.InfoBoxBody>
  );
};
